import { render, staticRenderFns } from "./LayoutIndex.vue?vue&type=template&id=040e10ea&scoped=true"
import script from "./LayoutIndex.vue?vue&type=script&lang=js"
export * from "./LayoutIndex.vue?vue&type=script&lang=js"
import style0 from "./LayoutIndex.vue?vue&type=style&index=0&id=040e10ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "040e10ea",
  null
  
)

export default component.exports